"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    PluginTypes = _interopRequireWildcard(require("./PluginTypes")),
    PluginRepositorySingleton =
/*#__PURE__*/
function () {
  function a() {
    (0, _classCallCheck2.default)(this, a), this.plugins = [];
  }

  return (0, _createClass2.default)(a, [{
    key: "loadPlugin",
    value: function b(a) {
      this.plugin(a.name) || this.plugins.push(a);
    }
  }, {
    key: "wallets",
    value: function a() {
      return this.plugins.filter(function (a) {
        return a.type === PluginTypes.WALLET_SUPPORT;
      });
    }
  }, {
    key: "signatureProviders",
    value: function a() {
      return this.plugins.filter(function (a) {
        return a.type === PluginTypes.BLOCKCHAIN_SUPPORT;
      });
    }
  }, {
    key: "supportedBlockchains",
    value: function a() {
      return this.signatureProviders().map(function () {
        return name;
      });
    }
  }, {
    key: "plugin",
    value: function b(a) {
      return this.plugins.find(function (b) {
        return b.name === a;
      });
    }
  }, {
    key: "endorsedNetworks",
    value: function () {
      var a = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function a() {
        return _regenerator.default.wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                return a.next = 2, Promise.all(this.signatureProviders().map(
                /*#__PURE__*/
                function () {
                  var a = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function a(b) {
                    return _regenerator.default.wrap(function (a) {
                      for (;;) {
                        switch (a.prev = a.next) {
                          case 0:
                            return a.next = 2, b.getEndorsedNetwork();

                          case 2:
                            return a.abrupt("return", a.sent);

                          case 3:
                          case "end":
                            return a.stop();
                        }
                      }
                    }, a, this);
                  }));
                  return function () {
                    return a.apply(this, arguments);
                  };
                }()));

              case 2:
                return a.abrupt("return", a.sent);

              case 3:
              case "end":
                return a.stop();
            }
          }
        }, a, this);
      }));
      return function b() {
        return a.apply(this, arguments);
      };
    }()
  }]), a;
}(),
    PluginRepository = new PluginRepositorySingleton(),
    _default = PluginRepository;

exports.default = _default;